import { Archive, Clone1, OutlineEye } from 'assets/assetsV1/iconComponents';

import { AgGridKebabMenuOptions } from 'uiToolkitV1/AgGridWrapperV2/types';

export const generateReviewTemplateListOptions = ({
  data,
  onViewClick,
  selectedTemplateId,
  onArchiveClick,
  onDuplicateClick,
  onUnarchiveClick,
}: {
  data: {
    [key: string]: any;
  };
  onViewClick: (data: any) => void;
  selectedTemplateId: 'active' | 'archived' | 'sample';
  onArchiveClick: (data: any) => void;
  onDuplicateClick: (data: any) => void;
  onUnarchiveClick: (data: any) => void;
}) => {
  const options = [] as AgGridKebabMenuOptions;
  options.push({
    label: 'View',
    onClick: () => {
      onViewClick(data);
    },
    Icon: OutlineEye,
  });

  if (selectedTemplateId === 'active') {
    options.push({
      label: 'Archive',
      onClick: () => {
        onArchiveClick(data);
      },
      Icon: Archive,
    });
    options.push({
      label: 'Duplicate',
      onClick: () => {
        onDuplicateClick(data);
      },
      Icon: Clone1,
    });
  } else if (selectedTemplateId === 'archived') {
    options.push({
      label: 'Unarchive',
      onClick: () => {
        onUnarchiveClick(data);
      },
      Icon: Archive,
    });
  }

  console.log({ selectedTemplateId });

  return options;
};
